// extracted by mini-css-extract-plugin
export default {"element":"Shape_element__Fcyn-","transparent":"Shape_transparent__KmfGM","wrap":"Shape_wrap__PXGAh","hidden":"Shape_hidden__XtQHQ"};